// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"order-adjustment.column"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7 9L4 12L7 15M13 4V20M20.75 12H5.25M19 9L22 12L19 15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-order-adjustment-column')
export default class OrderAdjustmentColumnIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'order-adjustment-column',
    }
  }
}
